/* eslint-disable camelcase */
import React from 'react';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { addServiceTypeR } from 'actions/ServiceTypesActions';
import Modal from '../Modal';
import FormInput from '../forms/FormInput';
import FormLangRichEditor from '../forms/FormLangRichEditor';
import FormAutocomplete from '../forms/FormAutocomplete';
import Loader from '../layout/Loader';
import FormLangInput from '../forms/FormLangInput';

class SubscriptionNew extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      title: undefined,
      name: undefined, // name is type
      description: undefined,
      primary_rate: undefined,
      secondary_rate: undefined,
      pending: false, // wird ersetzt durch reducerpending
    };
  }

  createServiceType = () => {
    const { title, name, description, primary_rate, secondary_rate } = this.state;
    this.props.addServiceTypeR({
      name,
      title,
      description,
      primaryRate: primary_rate,
      secondaryRate: secondary_rate,
    });
    this.props.close();
  };

  render() {
    const { intl, show, close } = this.props;
    const { title, name, description, primary_rate, secondary_rate } = this.state;
    const messages = intl.messages;
    let createDisabled = 'disabled';
    if (
      title !== undefined &&
      name !== undefined &&
      description !== undefined &&
      primary_rate !== undefined &&
      secondary_rate !== undefined
    ) {
      createDisabled = '';
    } else {
      createDisabled = 'disabled';
    }

    // name options
    let type_options = [
      messages.service_type_onboarding,
      messages.service_type_subscriptions,
      messages.service_type_additional_services,
      messages.service_type_product_sales,
    ];

    return (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>{messages.create_provision_type}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={12}>
              <div className="form-group form-group-default p-t-10 p-b-10 addSubscriptionForm">
                <FormLangInput
                  label={messages.provision_service_title}
                  name="title"
                  value={this.state.title}
                  onChange={(name, value) => this.setState({ title: value })}
                />
                <FormAutocomplete
                  onChange={(name, value) => this.setState({ name: value })}
                  label={messages.provision_service_type}
                  name="name"
                  value=""
                  options={type_options.map(option => {
                    return { label: option, value: option };
                  })}
                />
                <FormLangRichEditor
                  name="description"
                  label={messages.provision_service_description_text}
                  value={this.state.description}
                  onChange={(name, value) => this.setState({ description: value })}
                />
                <FormInput
                  type="number"
                  label={messages.provision_service_primary_rate}
                  name="primary_rate"
                  onChange={(name, value) => this.setState({ primary_rate: value })}
                  value={this.state.primary_rate}
                  disabled=""
                />
                <FormInput
                  type="number"
                  label={messages.provision_service_secondary_rate}
                  name="secondary_rate"
                  onChange={(name, value) => this.setState({ secondary_rate: value })}
                  value={this.state.secondary_rate}
                  disabled=""
                />

                {this.state.pending ? <Loader /> : <></>}
                <Button
                  onClick={() => this.createServiceType()}
                  disabled={createDisabled}
                  bsStyle="primary"
                  className="pull-right"
                  title="create_service_type"
                >
                  <span className="hidden-xs">{messages.create_provision_type}</span>
                </Button>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
  };
};

const mapDispatchToProps = {
  addServiceTypeR,
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(SubscriptionNew)
  )
);
